import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DEFAULT_TITLE = "Page not found";
const DEFAULT_LEAD =
  "That URL doesn't match anything in this app. Check the address or go back to search.";

/**
 * Shared “not found” / error layout for unknown routes, missing users, missing repos, etc.
 */
const NotFound = ({
  code = "404",
  title = DEFAULT_TITLE,
  lead = DEFAULT_LEAD,
  /** Sets document.title; defaults from title */
  documentTitle,
  /** Show secondary link to About */
  showAbout = true,
}) => {
  useEffect(() => {
    document.title =
      documentTitle ||
      (code === "404" ? `404 | ${title} · GitHub Finder` : `${title} · GitHub Finder`);
  }, [documentTitle, code, title]);

  const codeIsNumeric = /^\d{3}$/.test(String(code).trim());

  return (
    <main
      className="gf-container gf-not-found"
      aria-labelledby="gf-not-found-title"
    >
      <div className="gf-not-found__surface">
        <div className="gf-not-found__content">
          <p
            className={`gf-not-found__code${codeIsNumeric ? "" : " gf-not-found__code--text"}`}
            aria-hidden="true"
          >
            {code}
          </p>
          <h1 id="gf-not-found-title" className="gf-not-found__title">
            {title}
          </h1>
          <p className="gf-muted gf-not-found__lead">{lead}</p>
          <div className="gf-not-found__actions">
            <Link to="/" className="gf-btn gf-btn--primary gf-btn--sm">
              Back to search
            </Link>
            {showAbout && (
              <Link to="/about" className="gf-btn gf-btn--outline gf-btn--sm">
                About
              </Link>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
